export default "images/剩余电量-电量充足.png";